import React, { useState } from "react";

const RefundPolicy = (props) => {
  const [state, setState] = useState({
  });

  const handleChange = (e) => {
    const { name } = e.target;
    setState((prevState) => ({ ...prevState, [name]: e.target.value }));
  };

  const isValid = () => {
    return state.checked && state.liability_waiver_signature;
  };

  const setTodaysDate = () => {
    let options = { year: "numeric", month: "long", day: "numeric" };
    return new Date().toLocaleDateString("en-US", options);
  };

  return (
    <div>
      <div className={"refund-policy-tile"}>
        <h1 className="form-heading">{"Event Refund Policy"}</h1>
        <p>
          Refund Policy Text Goes Here...
        </p>
      </div>
    </div>
  );
};
export default RefundPolicy;
